import { createStyles, WithStyles, withStyles } from "@material-ui/core";
import { useTranslations } from "adapters/i18n";
import { PortalRoutes } from "constants/routes";
import React, { useEffect, useState } from "react";
import { Route, Switch } from "react-router-dom";
import ClienteService from "services/ClienteService";
import { getSelectedClientFromStorage } from "shared/storageUtils";
import { AppBarConteudoDefault, AppBar } from "../layout";
import ScrollToTop from "../shared/components/ScrollToTop";
import UserCreationPage from "./views/create/userCreationPage";
import UserEditionPage from "./views/edit/userEditionPage";
import UserListContainer from "./views/list/userListContainer";

type UserManagementRouterProps = WithStyles<typeof styles>;

const UserManagementRouter = ({ classes }: UserManagementRouterProps) => {
  return (
    <>
      <ScrollToTop />
      <div className={classes.root}>
        <AppBar
          conteudoCustomizadoAppBar={<ClientNameAppBar />}
          id="appBarPersonalizado"
        />
        <main className={classes.container}>
          <Switch>
            <Route
              exact
              path={PortalRoutes.USER_MANAGEMENT}
              component={UserListContainer}
            />
            <Route
              exact
              path={PortalRoutes.CREATE_NEW_USER}
              component={UserCreationPage}
            />
            <Route
              exact
              path={PortalRoutes.EDIT_USER}
              component={UserEditionPage}
            />
          </Switch>
        </main>
      </div>
    </>
  );
};

function ClientNameAppBar() {
  const { t } = useTranslations();
  const [clientName, setClientName] = useState<string | null>(null);

  useEffect(() => {
    const getClientName = async () => {
      const clientId = getSelectedClientFromStorage();
      if (clientId == null) return;

      const response = await ClienteService.listarDadosClientes([clientId]);
      const name = response[0].NomeReduzido;
      setClientName(name ?? null);
    };

    getClientName();
  }, []);

  return (
    <AppBarConteudoDefault
      tituloAppBar={t("common:client-x", { clientName: clientName ?? "" })}
    />
  );
}

const styles = () =>
  createStyles({
    root: {
      "& header": {
        background: "#F8F8F8",
      },
    },
    container: {
      padding: "40px",
      background: "#FFF",
    },
  });

export default withStyles(styles)(UserManagementRouter);
